import { createSlice } from "@reduxjs/toolkit";

const aiBuilderSlice = createSlice({
  name: "builder",
  initialState: {
    session: null,
    messages: [],
    nodes: [],
    edges: [],
    states: [],
    activities: [],
    transitions: [],
    stageGates: [],
    workflowDataFields: [],
    activityDataFields: [],
    isLoading: false,
    activeTab: 'diagram',
    selectedNode: null,
    recordViews: [],
    activityTriggers: [],
    activityPermissions: [],
    workflowName: '',
  },
  reducers: {
    setSession: (state, action) => {
      state.session = action.payload;
    },
    setMessages: (state, action) => {
      state.messages = action.payload;
    },
    addMessage: (state, action) => {
      state.messages.push(action.payload);
    },
    setNodes: (state, action) => {
      state.nodes = action.payload;
    },
    setEdges: (state, action) => {
      state.edges = action.payload;
    },
    setActivities: (state, action) => {
      state.activities = action.payload;
    },
    setWorkflowDataFields: (state, action) => {
      state.workflowDataFields = action.payload;
    },
    setActivityDataFields: (state, action) => {
      state.activityDataFields = action.payload;
    },
    setRecordViews: (state, action) => {
      state.recordViews = action.payload;
    },
    setActivityTriggers: (state, action) => {
      state.activityTriggers = action.payload;
    },
    setActivityPermissions: (state, action) => {
      state.activityPermissions = action.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    setSelectedNode: (state, action) => {
      state.selectedNode = action.payload;
    },
    updateWorkflowState: (state, action) => {
      const ws = action.payload;
      if (ws.nodes) state.nodes = ws.nodes;
      if (ws.edges) state.edges = ws.edges;
      if (ws.states) state.states = ws.states;
      if (ws.activities) state.activities = ws.activities;
      if (ws.transitions) state.transitions = ws.transitions;
      if (ws.stageGates) state.stageGates = ws.stageGates;
      if (ws.workflowDataFields) state.workflowDataFields = ws.workflowDataFields;
      if (ws.activityDataFields) state.activityDataFields = ws.activityDataFields;
      if (ws.recordViews) state.recordViews = ws.recordViews;
      if (ws.activityTriggers) state.activityTriggers = ws.activityTriggers;
      if (ws.activityPermissions) state.activityPermissions = ws.activityPermissions;
      if (ws.workflowName) state.workflowName = ws.workflowName;
      if (ws.conversationState && state.session) {
        state.session.conversation_state = ws.conversationState;
      }
    },
    resetState: () => ({
      session: null,
      messages: [],
      nodes: [],
      edges: [],
      states: [],
      activities: [],
      transitions: [],
      stageGates: [],
      workflowDataFields: [],
      activityDataFields: [],
      isLoading: false,
      activeTab: 'diagram',
      selectedNode: null,
      recordViews: [],
      activityTriggers: [],
      activityPermissions: [],
      workflowName: '',
    }),
  },
});

export default aiBuilderSlice;
